import authAxiosObs from "common/axios/authAxiosObservable";
import models from "modules/models";
export default class AssistantAiApiService {
  createAssistant(data) {
    return authAxiosObs.post(`/${models.ASSISTANT}`, { data: data });
  }
  updateAssistant(data) {
    return authAxiosObs.put(`/${models.ASSISTANT}`, { data: data });
  }
  askQuestion(data) {
    return authAxiosObs.put(`/${models.ASSISTANT}/askquestion`, { data: data });
  }
}
